import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["size"];
import React from 'react';
import styled from 'styled-components';
import { Box } from '../Box';
import { DividerSize, DividerOrientation } from './Divider.decl';
import { makeDividerSize, shouldForwardProp } from './utils';
export var Divider = styled(function (_ref) {
  var size = _ref.size,
      otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Box, otherProps);
}).withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "Divider",
  componentId: "sc-th8c6m-0"
})(["", ""], makeDividerSize);
Divider.defaultProps = {
  size: DividerSize.SMALL,
  orientation: DividerOrientation.VERTICAL,
  bg: 'grey.light'
};